import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import SquareMgmtModal from '../components/SqaureMgmtModal'; // Import the admin-specific modal
import axios from '../utils/axiosInstance';
import '../assets/css/adminpanel.css';
import '../assets/css/squaremanagement.css';

// Set app element for React Modal
Modal.setAppElement('#root'); // Accessibility compliance for screen readers

const SquareManagement = () => {
    const [squares, setSquares] = useState([]);
    const [topLabels, setTopLabels] = useState([]);
    const [sideLabels, setSideLabels] = useState([]);
    const [homeTeam, setHomeTeam] = useState({ name: 'Home Team', color: '#CCCCCC' });
    const [awayTeam, setAwayTeam] = useState({ name: 'Away Team', color: '#CCCCCC' });
    const [price, setPrice] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSquare, setSelectedSquare] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError('');
            try {
                const [
                    squareResponse,
                    boardResponse,
                    labelResponse,
                    teamResponse,
                    priceResponse,
                ] = await Promise.all([
                    axios.get('/squares'),
                    axios.get('/board/status'),
                    axios.get('/board/grid-labels'),
                    axios.get('/board/add-teams'),
                    axios.get('/board/price'),
                ]);

                setSquares(squareResponse.data);
                setTopLabels(labelResponse.data.topLabels);
                setSideLabels(labelResponse.data.sideLabels);
                setHomeTeam(teamResponse.data.homeTeam);
                setAwayTeam(teamResponse.data.awayTeam);
                setPrice(priceResponse.data.price || 0);
            } catch (err) {
                setError('Failed to load data. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSquareClick = (square) => {
        setSelectedSquare(square);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedSquare(null);
    };

    const handleSquareUpdate = async () => {
        try {
            const response = await axios.get('/squares');
            setSquares(response.data);
        } catch (error) {
            console.error('Error refreshing squares:', error);
        }
    };

    if (loading) return <p className="loading">Loading grid data...</p>;

    return (
        <div className="admin-panel container square-management">
            <header>
                <h2>Square Management</h2>
                <p>Price per square: ${price}</p>
                <nav>
                    <Link to="/admin" className="admin-link">Back to Admin Panel</Link>
                </nav>
            </header>
            {error && <p className="error">{error}</p>}
            <table className="grid-table">
                <thead>
                    <tr>
                        <th></th>
                        <th colSpan="10" className="team-header" style={{ color: homeTeam.color }}>
                            <h3>{homeTeam.name}</h3>
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        {topLabels.map((label, index) => (
                            <th key={`top-${index}`} className="header-cell">
                                {label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sideLabels.map((rowLabel, rowIndex) => (
                        <tr key={`row-${rowIndex}`}>
                            {rowIndex === 0 && (
                                <th
                                    rowSpan="10"
                                    className="team-header vertical"
                                    style={{ color: awayTeam.color }}
                                >
                                    <h3>{awayTeam.name}</h3>
                                </th>
                            )}
                            <th className="header-cell">{rowLabel}</th>
                            {squares
                                .filter((square) => square.id.startsWith(sideLabels[rowIndex]))
                                .map((square) => (
                                    <td
                                        key={square.id}
                                        className={`grid-cell ${
                                            square.isPurchased ? 'purchased' : 'available'
                                        }`}
                                        style={{
                                            backgroundColor: square.isPurchased
                                                ? square.playerColor || '#ccc'
                                                : '#f8f9fa',
                                        }}
                                        onClick={() => handleSquareClick(square)}
                                    >
                                        {!square.isPurchased && (
                                            <span className="square-label">{square.id}</span>
                                        )}
                                        {square.isPurchased && (
                                            <span className="square-purchaser">
                                                {square.purchaserName || 'Unknown'}
                                            </span>
                                        )}
                                    </td>
                                ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            {isModalOpen && (
                <SquareMgmtModal
                    isOpen={isModalOpen}
                    selectedSquare={selectedSquare}
                    onClose={handleModalClose}
                    onUpdate={handleSquareUpdate}
                />
            )}
        </div>
    );
};

export default SquareManagement;